import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { Mutation } from 'react-apollo'
import { Button, DialogActions, TextField } from '../../../node_modules/@mui/material'
import { i18n } from '../index'
import css from './noteDialog.css'
import { updateNote } from './weeklyInfoQueries'
type NoteDialogProps = {
  note: any
  isOpen: boolean
  onClose: (...args: Array<any>) => any
}
const defaultFormData = {
  body: '',
}

class NoteDialog extends React.PureComponent<NoteDialogProps> {
  state = {
    formData: { ...defaultFormData },
  }

  componentDidMount() {
    const { note } = this.props

    if (note) {
      this.setStateFromData(note)
    }
  }

  componentDidUpdate(prevProps: NoteDialogProps) {
    const { note } = this.props

    if (note && JSON.stringify(note) !== JSON.stringify(prevProps.note)) {
      this.setStateFromData(note)
    }
  }

  setStateFromData = (note: any) => {
    this.setState({
      formData: { ...defaultFormData, ...note },
    })
  }
  onInput = (fieldName: string, newValue: string | number) => {
    this.setState({
      formData: { ...this.state.formData, [fieldName]: newValue },
    })
  }
  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { note } = this.props
    const { body } = this.state.formData
    onMutate({
      variables: {
        noteId: note.id,
        updatedBody: body,
      },
    })
    this.props.onClose()
  }
  onReset = () => {
    this.setState({
      formData: { ...defaultFormData },
    })
  }

  render() {
    const { isOpen, onClose } = this.props
    const { formData } = this.state
    return (
      <Dialog
        /* disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
        className={css.component}
      >
        <DialogTitle id='form-dialog-title'>{i18n.t('noteDialog.editNote')}</DialogTitle>
        <DialogContent>
          <Mutation mutation={updateNote}>
            {(onMutate) => (
              <form onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.formComponent}>
                <TextField
                  autoFocus
                  required
                  multiline={true}
                  label={i18n.t('noteDialog.label')}
                  value={formData.body}
                  onChange={(e) => this.onInput('body', e.target.value)}
                  className={css.textField}
                />
                <DialogActions className={css.actions}>
                  <Button type='button' onClick={() => onClose()}>
                    {i18n.t('buttons.cancel')}
                  </Button>
                  <Button type='submit' color='primary'>
                    {i18n.t('buttons.save')}
                  </Button>
                </DialogActions>
              </form>
            )}
          </Mutation>
        </DialogContent>
      </Dialog>
    )
  }
}

export default NoteDialog
